const emptyGeojson = {
  type: 'FeatureCollection',
  features: [],
};

export const fetchMapDatasetGeojson = async (mapDatasets = []) => {
  const datasetPromises = mapDatasets.map(async (mapDataset) => {
    const { datapointsGeojsonUrl } = mapDataset;

    if (!datapointsGeojsonUrl) {
      return {
        ...mapDataset,
        datapointsGeojson: emptyGeojson,
      };
    }

    try {
      const response = await fetch(datapointsGeojsonUrl);
      const datapointsGeojson = response.status === 200
        ? await response.json()
        : emptyGeojson;

      return {
        ...mapDataset,
        datapointsGeojson,
      };
    } catch (error) {
      return {
        ...mapDataset,
        datapointsGeojson: emptyGeojson,
      };
    }
  });

  return Promise.all(datasetPromises);
};

export const withEmptyDatapointsGeojson = (mapDatasets = []) => mapDatasets.map(mapDataset => ({
  ...mapDataset,
  datapointsGeojson: mapDataset.datapointsGeojson || emptyGeojson,
}));
